export const homeTranslations = {
  fr: {
    hero: {
      title: 'Et si ce que vous vivez avait du sens ?',
      subtitle: 'Comprendre ce que vous vivez pour avancer avec plus de sérénité.',
      cta: 'Prendre rendez-vous'
    },
    
    professional: {
      title: 'Un accompagnement professionnel et humain',
      description: 'Depuis plus de 20 ans, j\'accompagne les personnes, les couples et les familles dans les moments de questionnement, de transition ou de difficulté relationnelle.',
      approach: 'Mon approche combine différentes méthodes : numérologie, accompagnement de couple et familial, coaching de vie et accompagnement énergétique.',
      goal: 'Mon objectif est de vous aider à mieux comprendre ce que vous vivez pour retrouver clarté, confiance et sérénité.'
    },
    
    services: {
      title: 'Comment puis-je vous aider ?',
      numerology: {
        title: 'Numérologie',
        description: 'Comprenez vos potentiels, vos défis de vie et vos cycles actuels grâce à votre thème numérologique complet.'
      },
      therapy: {
        title: 'Accompagnement de couple et familial',
        description: 'Améliorez la communication, apaisez les tensions et renforcez les liens au sein de votre couple ou famille.'
      },
      coaching: {
        title: 'Coaching de vie',
        description: 'Traversez les périodes de changement avec plus de clarté et de confiance grâce à un accompagnement personnalisé.'
      },
      energy: {
        title: 'Accompagnement énergétique',
        description: 'Prenez un temps pour vous, favorisez la détente et retrouvez une sensation d\'harmonie intérieure.'
      },
      cta: 'Prendre rendez-vous'
    },
    
    finalCta: {
      title: 'Prêt(e) à faire le premier pas ?',
      subtitle: 'Réservez un appel découverte gratuit de 30 minutes',
      button: 'Prendre rendez-vous (30 min offertes)'
    },

    freeTest: {
      badge: 'Test gratuit · 2 minutes',
      title: 'Quelle place prenez-vous dans vos relations ?',
      description: 'Répondez à 5 questions simples et découvrez la place que vous prenez spontanément avec les autres. Une première porte d\'entrée vers une meilleure connaissance de vous-même.',
      button: 'Faire le test gratuit'
    }
  },
  
  es: {
    hero: {
      title: '¿Y si lo que vives tuviera sentido?',
      subtitle: 'Comprender lo que vives para avanzar con más serenidad.',
      cta: 'Reservar cita'
    },
    
    professional: {
      title: 'Un acompañamiento profesional y humano',
      description: 'Desde hace más de 20 años, acompaño a personas, parejas y familias en momentos de cuestionamiento, transición o dificultad relacional.',
      approach: 'Mi enfoque combina diferentes métodos: numerología, acompañamiento de pareja y familiar, coaching de vida y acompañamiento energético.',
      goal: 'Mi objetivo es ayudarte a comprender mejor lo que vives para recuperar claridad, confianza y serenidad.'
    },
    
    services: {
      title: '¿Cómo puedo ayudarte?',
      numerology: {
        title: 'Numerología',
        description: 'Comprende tus potenciales, tus desafíos de vida y tus ciclos actuales a través de tu tema numerológico completo.'
      },
      therapy: {
        title: 'Acompañamiento de pareja y familiar',
        description: 'Mejorad la comunicación, reducid las tensiones y fortaleced los vínculos de pareja o familiares.'
      },
      coaching: {
        title: 'Coaching de vida',
        description: 'Atraviesa los períodos de cambio con más claridad y confianza gracias a un acompañamiento personalizado.'
      },
      energy: {
        title: 'Acompañamiento energético',
        description: 'Dedica un momento a ti, favorece la relajación y recupera una sensación de armonía interior.'
      },
      cta: 'Reservar cita'
    },
    
    finalCta: {
      title: '¿List@ para dar el primer paso?',
      subtitle: 'Reserva una llamada descubrimiento gratuita de 30 minutos',
      button: 'Reservar cita (30 min ofrecidos)'
    },

    freeTest: {
      badge: 'Test gratuito · 2 minutos',
      title: '¿Qué lugar ocupas en tus relaciones?',
      description: 'Responde a 5 preguntas sencillas y descubre el lugar que ocupas espontáneamente con los demás. Una primera puerta de entrada hacia un mejor conocimiento de ti mismo.',
      button: 'Hacer el test gratuito'
    }
  }
};
